/*
 * Object representing an error (following JSON-API)
 * http://jsonapi.org/format/#error-objects
 */
export class ApiError extends Error {
  /**
   * a unique identifier for this particular occurrence of the problem.
   */
  public id: string
  /**
   * a links object containing the following members:
   * - about: a link that leads to further details about this particular occurrence of the problem.
   */
  public links: { about: string }
  /**
   * the HTTP status code applicable to this problem, expressed as a string value.
   */
  public status: string
  /**
   * an application-specific error code, expressed as a string value.
   */
  public code: string
  /**
   * a short, human-readable summary of the problem that SHOULD NOT change from occurrence to occurrence of the problem,
   * except for purposes of localization.
   */
  public set title(value: string) { this.message = value }
  public get title(): string { return this.message }
  /**
   * a human-readable explanation specific to this occurrence of the problem.
   * Like title, this field's value can be localized.
   */
  public detail: string
  /**
   * an object containing references to the source of the error, optionally including any of the following members:
   * - a JSON Pointer [RFC6901] to the associated entity in the request document [e.g. "/data" for a primary data object,
   *   or "/data/attributes/title" for a specific attribute].
   * - a string indicating which URI query parameter caused the error.
   */
  public source: { [key: string]: string, pointer?: string, parameter?: string }
  /**
   * a meta object containing non-standard meta-information about the error
   */
  public meta: any

  constructor(message: string = 'An unknown API Error occurred') {
    super(message)
    Object.setPrototypeOf(this, ApiError.prototype)
    this.name = this.constructor.name
    this.title = message
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/errors/api-error.ts